import t, { keyframes as a, css as r } from "styled-components";
import { Button as d } from "./atoms-v26.js";
import { Base as s, UL as g, LI as p } from "./atoms-v2777.js";
const u = a`
  from { opacity: 0; }
  to { opacity: 1; }
`, b = t.div`
  ${s}

  position: relative;
`, $ = t(d)`
  border-radius: ${({ theme: o }) => o == null ? void 0 : o.get("tokens.radius.buttonSmallRounded")}px;
  padding: 14px;

  ${({ $colorTheme: o, $isOpen: n }) => n && r`
      background-color: ${({ theme: i }) => i == null ? void 0 : i.get(`ui.button.ghost.${o}.hover`)};

      &:hover {
        background-color: ${({ theme: i }) => i == null ? void 0 : i.get(`ui.button.ghost.${o}.hover`)};
      }
    `}

  &:focus-visible {
    background-color: ${({ $colorTheme: o, theme: n }) => n == null ? void 0 : n.get(`ui.button.ghost.${o}.hover`)};
  }
`, f = t.nav`
  animation-duration: ${({ theme: o }) => o == null ? void 0 : o.get("tokens.motion").toString("duration.fast")};
  animation-name: ${u};
  animation-timing-function: ${({ theme: o }) => o == null ? void 0 : o.get("tokens.motion").toString("easing.standard")};
  background-color: ${({ $colorTheme: o, theme: n }) => n == null ? void 0 : n.get(`tokens.surface.${o}.background`)};
  border-radius: ${({ theme: o }) => o == null ? void 0 : o.get("tokens.radius.modalRadius")}px;
  box-shadow: 0 8px 20px 2px rgba(0 0 0 / 0.28);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  margin-top: ${({ $toggleAndMenuGap: o }) => `${o}px`};
  max-height: 500px !important;
  overflow: hidden;
  padding: 16px;
  width: 180px;
  z-index: ${({ theme: o }) => (o == null ? void 0 : o.get("tokens.zindex.modal")) - 1};
`, k = t.ul`
  ${g}

  display: flex;
  flex-direction: column;
  gap: 6px;
  list-style: none;
  padding: 0;
`, v = t.li`
  ${p}
`, y = t(d)`
  border-radius: 0;
  justify-content: start;
  padding-left: 16px;
  padding-right: 16px;
  text-align: left;
  text-decoration: none;
  white-space: nowrap;
  width: 100%;
`, w = t.div`
  display: flex;
  flex-direction: column;
  padding: 0;

  ${({ $colorTheme: o, $isLastItem: n }) => !n && r`
      border-bottom: 1px solid ${({ theme: i }) => i == null ? void 0 : i.get(`tokens.border.${o}.light`)};
      margin-bottom: 12px;
      padding-bottom: 12px;
    `}
`;
export {
  f as Menu,
  w as MenuGroup,
  v as MenuItem,
  y as MenuItemButton,
  k as MenuItems,
  b as OverflowMenu,
  $ as Toggle
};
